import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-landing',
  imports: [MatButtonModule, RouterModule],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent {

  header = environment.header;
  highlightHeader = environment.highlightHeader;
  primaryHeader = environment.primaryHeader;
  description = environment.description;

}
